import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TablistService, tabModel } from '../tablist.service';
import { SearchKeywordsModalComponent } from 'src/app/shared/modals/search-keywords-modal/search-keywords-modal.component';
import { FileRequestModel } from '../../models/file/file-request-model';

@Injectable({
  providedIn: 'root'
})
export class KeywordSearchModalService {
  givenMiniIndex: number = 0;
  documents: any;
  @Output() modelChanged = new EventEmitter<any>();

  openTabs: tabModel[] = [];

  constructor(private modalService: NgbModal, private modal2: NgbModalConfig,
    private tablistService: TablistService) {
  }

  openModal(entityName: string, sourceOCREntityFileRequest: FileRequestModel) {
    var modalRef!: NgbModalRef;

    modalRef = this.modalService.open(SearchKeywordsModalComponent, { size: 'lg', centered: true, windowClass: "openModal", backdropClass: 'static', backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.sourceOCREntityFileRequest = sourceOCREntityFileRequest;
    modalRef.componentInstance.targetEntityFileUpload = sourceOCREntityFileRequest.getFileList;
    modalRef.componentInstance.entityName = entityName;
  }
}